import consumer from "@/channels/consumer";
import type { WhatsappStatus } from "@/types/whatsapp";
import { useEffect, useRef } from "react";

type QrCodeUpdatePayload = {
  event: "qrcode_updated";
  qrCode: string;
};

type ConnectionUpdatePayload = {
  event: "connection_update";
  status: WhatsappStatus["status"];
  number?: string;
};

type WhatsappConnectionPayload = QrCodeUpdatePayload | ConnectionUpdatePayload;

type UseWhatsappConnectionOptions = {
  onQrCodeUpdate?: (qrCode: string) => void;
  onConnectionUpdate?: (
    status: WhatsappStatus["status"],
    number?: string,
  ) => void;
};

export function useWhatsappConnection({
  onQrCodeUpdate,
  onConnectionUpdate,
}: UseWhatsappConnectionOptions) {
  const onQrCodeUpdateRef = useRef(onQrCodeUpdate);
  onQrCodeUpdateRef.current = onQrCodeUpdate;

  const onConnectionUpdateRef = useRef(onConnectionUpdate);
  onConnectionUpdateRef.current = onConnectionUpdate;

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      "WhatsappConnectionChannel",
      {
        received(data: WhatsappConnectionPayload) {
          if (data.event === "qrcode_updated") {
            onQrCodeUpdateRef.current?.(data.qrCode);
          } else if (data.event === "connection_update") {
            onConnectionUpdateRef.current?.(data.status, data.number);
          }
        },
      },
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);
}
